import {
  memberCreateApi,
  memberDeleteApi,
  memberDetailApi,
  memberEditApi,
  memberListApi,
} from "../../core/http/httpClient";
import { makeAsyncApiCall } from "../common";
import { takeEveryFsa } from "../operations";
import { memberActions } from "./actions";
import { call, put } from "typed-redux-saga";
import { authActions } from "../auth/actions";
import { getCurrentUserFromStorage, updateLocalStorageIfCurrentUser } from "../../utils/auth";
import { ApiResponse } from "../../core/types";

export function* memberSaga() {
  yield takeEveryFsa(memberActions.fetchMembers.started, function* (action) {
    yield* makeAsyncApiCall(action, memberActions.fetchMembers, memberListApi);
  });

  yield takeEveryFsa(
    memberActions.getMemberDetails.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        memberActions.getMemberDetails,
        memberDetailApi
      );
    }
  );

  yield takeEveryFsa(memberActions.createNewMember.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      memberActions.createNewMember,
      memberCreateApi
    );
  });

  yield takeEveryFsa(memberActions.updateMember.started, function* (action) {
    const { onComplete, onError, onSuccess, ...body } = action.payload;

    // Get current logged-in user from local storage
    const currentUser = getCurrentUserFromStorage();

    // Make the API call using the common pattern
    const apiResult: ApiResponse<any> = yield* call(() => {
      return memberEditApi
        .call(body)
        .then((response) => ({ response }))
        .catch((error) => ({ error }));
    });

    onComplete?.();

    if (!apiResult.response || apiResult.error) return onError?.(apiResult.error);

    // Check if the updated member is the current logged-in user and update local storage
    const wasLocalStorageUpdated = updateLocalStorageIfCurrentUser(
      apiResult.response.data,
      currentUser
    );

    // If local storage was updated, also update the auth state
    if (wasLocalStorageUpdated) {
      const updatedUserData = {
        id: apiResult.response.data.id,
        username: apiResult.response.data.username,
        email: apiResult.response.data.email,
        role: apiResult.response.data.role,
        last_login: apiResult.response.data.last_login,
      };

      yield* put(
        authActions.getUser.done({
          params: {},
          result: updatedUserData,
        })
      );
    }

    yield* put(
      memberActions.updateMember.done({
        params: action.payload,
        result: apiResult.response.data,
      })
    );
    onSuccess?.(apiResult.response.data);
  });

  yield takeEveryFsa(memberActions.deleteMember.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      memberActions.deleteMember,
      memberDeleteApi
    );
  });
}
